<template src="./paladin-group-lookup.html"></template>

<script>
 import {
   GroupApi,
   ApiSearchPagedRequest,
 } from '@chirhos/chirhos-api'
 import { ChiRhos } from '@paladin/core'
import PaladinTypeahead from '../typeahead/paladin-typeahead'

import _ from 'lodash'

let ChiRhosApi = new ChiRhos().api()
var groupApi = new GroupApi(ChiRhosApi)

export default {
  name: 'PaladinGroupLookup',
  components: { PaladinTypeahead, },
  props: {
    id: {
     type: String,
     default: null
    },
},
  data() {
    return {
      query: '',
      groups: [],
    }
  },
  computed: {

  },
  watch: {
    // When the query value changes, fetch new results from
    // the API - debounce the search to avoid hitting the API limits
    query: function(/* newQuery, oldQuery */) {
      this.debouncedSearchGroups()
    },
  },
   created: function() {
    this.debouncedSearchGroups = _.debounce(this.searchGroups, 500)
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {

      // any init needed here

    },
    searchGroups() {
      if (this.query && this.query.length >= 3) {
        groupApi
          .Lookup({
            request: new ApiSearchPagedRequest(this.query, 1, 100, false),
          })
          .then(
            (response) => {
              // console.log(response.data)
              this.groups = response.data
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
      }
    },
    select(group)
    {
      this.$emit('select', group)
    },
  },
}
</script>

<style lang="scss"></style>
